<div class="mx-auto my-5 hidden gap-10 px-3 md:container md:my-10 md:flex">
  <div class="product-filter w-80">
    <fc-product-filter
      #productFilter
      [selectedCategorySlugs]="selectedCategorySlugs"
      (setCategoryFilter)="setCategoryFilter($event)"
      [brands]="brands"
      [categories]="categories"
      (setSaleFilter)="setSaleFilter($event)"
      (setBrandFilter)="setBrandFilter($event)"
      (setPriceFilter)="setPriceFilter($event)"
      [selectedBrandIds]="selectedBrandIds"
      [selectedPriceRange]="selectedPriceRange"></fc-product-filter>
  </div>
  <div class="product-list mt-5 w-full md:mt-0" #productListContainer>
    <div class="product-list__header mb-3 flex items-center justify-between">
      <div class="total-product">
        Showing {{ products.length }} of {{ totalProducts }} results
      </div>
      <div class="sort relative">
        <div class="sort__dropdown relative">
          <button
            type="button"
            class="flex w-56 items-center justify-between rounded-lg border py-1 px-3 text-left"
            (click)="sortBy.toggle($event)">
            <span class="flex flex-1 items-center gap-1 text-left">
              <fa-icon
                class="text-sm"
                [icon]="
                  selectedSort.direction == 'ASC'
                    ? faSortAmountUp
                    : faSortAmountDown
                "></fa-icon>
              {{ selectedSort.label }}
            </span>
            <span
              class="transform transition duration-300 ease-in-out"
              [ngClass]="{
                '-rotate-180 transform': sortBy.dropdownOpened == true
              }">
              <fa-icon
                [icon]="faChevronDown"
                class="rotate-180 text-gray-500"></fa-icon
            ></span>
          </button>
          <fc-dropdown #sortBy fcStyleClass="fc-dropdown center w-full">
            <div
              class="dropdown-menu relative mt-1 rounded-lg bg-white py-2 shadow-md">
              <button
                type="button"
                class="dropdown-item block w-full px-4 py-1 text-left hover:bg-gray-100"
                *ngFor="let sort of sortDropdown"
                (click)="setSort(sort); sortBy.hide()">
                {{ sort.label }}
              </button>
            </div>
          </fc-dropdown>
        </div>
      </div>
    </div>
    <div class="product-list_current-filter mb-3">
      <div class="flex flex-wrap items-center gap-3" *ngIf="hasFilter">
        <button
          class="flex gap-3 rounded-full border py-1 px-3 text-gray-500"
          *ngIf="filteredItems.category"
          (click)="removeCategoryFilter()">
          {{ filteredItems.category.name }}
          <fa-icon [icon]="faTimesCircle"></fa-icon>
        </button>
        <button
          class="flex gap-3 rounded-full border py-1 px-3 text-gray-500"
          *ngFor="let brand of filteredItems.brands"
          (click)="removeBrandFilter(brand.id)">
          {{ brand.name }} <fa-icon [icon]="faTimesCircle"></fa-icon>
        </button>
        <button
          class="flex gap-3 rounded-full border py-1 px-3 text-gray-500"
          *ngIf="filteredItems.min_price"
          (click)="productFilter.onRemoveMinPrice()">
          Minimum Price
          <fa-icon [icon]="faTimesCircle"></fa-icon>
        </button>
        <button
          class="flex gap-3 rounded-full border py-1 px-3 text-gray-500"
          *ngIf="filteredItems.max_price"
          (click)="productFilter.onRemoveMaxPrice()">
          Maximum Price
          <fa-icon [icon]="faTimesCircle"></fa-icon>
        </button>
        <button
          type="button"
          class="cursor-pointer text-primary-md-dark hover:text-primary-darkest"
          (click)="productFilter.onRemoveAllFilter(); removeAllFilters()">
          Clear Filter
        </button>
      </div>
    </div>
    <div
      class="product-list__items grid grid-cols-2 gap-x-3 gap-y-5 lg:grid-cols-3 xl:grid-cols-5">
      <ng-container *ngIf="!loading">
        <div class="product-list__item" *ngFor="let product of products">
          <fc-product-item [product]="product"></fc-product-item>
        </div>
      </ng-container>
      <ng-container *ngIf="loading">
        <div class="product-list__loading" *ngFor="let item of [1, 2, 3, 4, 5]">
          <p-skeleton class="w-full" height="19rem"></p-skeleton>
        </div>
      </ng-container>
    </div>
    <div
      class="product-list__pagination flex justify-end py-3"
      *ngIf="!loading">
      <fc-pagination
        [totalItem]="totalProducts"
        [currentPage]="currentPage"
        [itemPerPage]="30"
        (pageChange)="pageChange($event)"></fc-pagination>
    </div>
  </div>
</div>

<div
  class="m-product-container hide-scrollbar relative md:hidden"
  [ngClass]="!isShop ? 'header-offset-margin' : ''">
  <div
    class="m-product-filter flex w-full items-center gap-3 bg-white px-3 py-2"
    [ngClass]="{
      'sticky top-16 right-0 z-10 border-b': fixedFilter
    }">
    <button
      class="flex items-center gap-2 rounded-full border py-1 px-6 text-sm"
      [ngClass]="
        hasFilter || selectedSort.label != 'Sort By'
          ? 'text-primary-md-dark'
          : 'text-gray-400'
      "
      (click)="mobileFilter.toggleMenu()">
      <fa-icon [icon]="faFilter"></fa-icon>
      <span>Filter</span>
    </button>
  </div>
  <div class="product p-3" #productList>
    <div class="product-list">
      <div class="grid w-full grid-cols-2 gap-3">
        <fc-product-item
          *ngFor="let product of products"
          [product]="product"></fc-product-item>
        <ng-container *ngIf="loading">
          <div class="product-list__loading" *ngFor="let item of [1, 2]">
            <p-skeleton class="w-full" height="19rem"></p-skeleton>
          </div>
        </ng-container>
      </div>
    </div>
  </div>
</div>

<fc-mobile-product-filter
  #mobileFilter
  [selectedCategorySlugs]="selectedCategorySlugs"
  (setCategoryFilter)="setCategoryFilter($event)"
  [brands]="brands"
  [categories]="categories"
  (setBrandFilter)="setBrandFilter($event)"
  (setPriceFilter)="setPriceFilter($event)"
  [selectedBrandIds]="selectedBrandIds"
  [selectedPriceRange]="selectedPriceRange"
  [sortList]="sortDropdown"
  [selectedSort]="selectedSort"
  (setSort)="setSort($event)"></fc-mobile-product-filter>
